import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export const useDict = defineStore('dict', {
  state: () => ({}),
  actions: {
    /**
     * 公共接口
     */
    async getAreaTreeCity() {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/dict/areaTreeCity',
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
